import React, { useState } from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { acceptCookies, rejectCookies } from 'flow/actions/app-actions';
import Button from 'flow/components/ui-components/Button';
import useAppContext from 'flow/hooks/useAppContext';
import TrackingConsentModal from 'flow/components/settings/TrackingConsentModal';

const bannerButtonClass =
    'hover:darken-20 bg-gray-600 whitespace-nowrap text-white';

const ConsentReminderBanner = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <div className="bg-gray-800 px-3 text-white">
                <div className="flex items-center justify-between gap-2 py-2 text-sm font-medium">
                    {i18next.t('cookie.reminder.message')}
                    <div className="flex shrink-0 gap-2">
                        <Button
                            className={bannerButtonClass}
                            onClick={() => setShowModal(true)}
                        >
                            {i18next.t('cookie.manage')}
                        </Button>
                        <Button
                            className={bannerButtonClass}
                            onClick={() => dispatch(rejectCookies())}
                        >
                            {i18next.t('cookie.reject')}
                        </Button>
                        <Button
                            className={bannerButtonClass}
                            onClick={() => dispatch(acceptCookies())}
                        >
                            {i18next.t('cookie.accept')}
                        </Button>
                    </div>
                </div>
            </div>
            <TrackingConsentModal
                open={showModal}
                onClose={() => setShowModal(false)}
                onDismiss={() => setShowModal(false)}
            />
        </>
    );
};

export default ConsentReminderBanner;
